export default __webpack_public_path__ + "static/media/Pross-Mac.9766ee97.webp";